var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cube-page',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"content",attrs:{"slot":"content"},slot:"content"},[_c('wmq-layout',{ref:"city",attrs:{"rootLayoutConfig":_vm.rootLayoutConfig}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }